/**
 * Auto-localization Script (v3)
 * Detects user location via Shopify Browsing Context Suggestions API
 * Automatically submits the localization form to switch country/currency
 */
document.addEventListener("DOMContentLoaded", () => {
  // Bumped version to v4 to force re-check for users with old cached session state
  const SESSION_KEY = "localization_checked_v4";
  const DEBUG_MODE = true; // Set to false in production

  /**
   * @param {string} message
   * @param {any} [data]
   */
  function log(message, data) {
    if (DEBUG_MODE) {
      console.log(`[Auto-Localization] ${message}`, data || "");
    }
  }

  // 1. Check if we already ran this session to avoid loop/refresh madness
  if (sessionStorage.getItem(SESSION_KEY)) {
    log("Already checked this session. Skipping.");
    return;
  }

  // 2. Determine the API endpoint
  // @ts-ignore
  const routes = window.Shopify && window.Shopify.routes;
  const root = routes ? routes.root : "/";
  const endpoint = `${root}browsing_context_suggestions.json`;

  log(`Fetching suggestions from ${endpoint}`);

  fetch(endpoint)
    .then((response) => {
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then((data) => {
      log("API Response:", data);

      if (!data.detected_values || !data.detected_values.country) {
        log("No country detected in response.");
        sessionStorage.setItem(SESSION_KEY, "done");
        return;
      }

      const detectedCode = data.detected_values.country.iso_code;
      log(`Detected Country Code: ${detectedCode}`);

      // 3. Find the localization form and inputs
      // Try different selectors to be robust
      const form =
        document.querySelector('form[action*="/localization"]') ||
        document.querySelector("#LocalizationForm");
      if (!form) {
        log("Localization form not found in DOM.");
        sessionStorage.setItem(SESSION_KEY, "done");
        return;
      }

      const countryInput = form.querySelector('input[name="country_code"]');
      if (!countryInput || !(countryInput instanceof HTMLInputElement)) {
        log('Country input (name="country_code") not found or invalid.');
        sessionStorage.setItem(SESSION_KEY, "done");
        return;
      }

      const currentCode = countryInput.value;
      log(`Current Store Country: ${currentCode}`);

      // 4. Compare and Switch
      if (currentCode === detectedCode) {
        log("Already on the detected country. No action needed.");
        sessionStorage.setItem(SESSION_KEY, "done");
        return;
      }

      // 5. Verify if the detected country is actually supported by the store (Markets)
      // We check if the ISO code exists in the form's options (list items or select options)
      const isSupported =
        form.querySelector(`li[data-value="${detectedCode}"]`) ||
        form.querySelector(`option[value="${detectedCode}"]`) ||
        document.querySelector(
          `localization-form-component li[data-value="${detectedCode}"]`,
        ); // Check across component boundary if needed

      if (isSupported) {
        log(`Switching from ${currentCode} to ${detectedCode}...`);

        // Set the flag in session storage BEFORE submitting to prevent loop if submission fails/reloads
        sessionStorage.setItem(SESSION_KEY, "done");

        // Update the input value
        countryInput.value = detectedCode;

        // Submit the form
        // We use .call() to bypass any potential submit variable conflicts on the form element
        HTMLFormElement.prototype.submit.call(form);
      } else {
        log(
          `Detected country ${detectedCode} is NOT supported by this store (not in markets list).`,
        );
        sessionStorage.setItem(SESSION_KEY, "done");
      }
    })
    .catch((error) => {
      console.error("[Auto-Localization] Error:", error);
      sessionStorage.setItem(SESSION_KEY, "done"); // Prevent infinite retries on error
    });
});
